//#region src/date-picker/utils/set-date-since.ts
var e = (e) => (e.setHours(0, 0, 0, 0), e);
//#endregion
export { e as setDateSince };
